import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './routes/App';
import { Provider } from 'react-redux';
import { store } from './redux/store/store';

import { BrowserRouter } from 'react-router-dom';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)

serviceWorkerRegistration.register();